
import { EpimsBaseEntityDto } from './epim-base.dto';

import { IsNotEmpty } from 'class-validator';

export class ProgressMeetingReportDto extends EpimsBaseEntityDto {

  @IsNotEmpty() ProgressMeetingReportId: string;
  @IsNotEmpty() MeetingReportTitle: string;
  @IsNotEmpty() MeetingReportDescription: string;
  @IsNotEmpty() DateReported: Date;
  @IsNotEmpty() ReportedBy: string;
  @IsNotEmpty() ProjectId: string;


}





